module.exports = __webpack_public_path__ + "img/flag-start.913adc45.png";